import { render, staticRenderFns } from "./GeneratorCatalog.vue?vue&type=template&id=b61aa0dc&"
import script from "./GeneratorCatalog.vue?vue&type=script&lang=js&"
export * from "./GeneratorCatalog.vue?vue&type=script&lang=js&"
import style0 from "./GeneratorCatalog.vue?vue&type=style&index=0&id=b61aa0dc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports